import { useBaseGarmentsAccess } from '@/features/base-garments/hooks/useBaseGarmentsAccess';
import { useClientPricesAccess } from './useClientPricesAccess';

export interface ProductsViews {
  baseGarments: boolean;
  clientPrices: boolean;
  /** At least one view besides Products: the page draws the view switch. */
  any: boolean;
}

/**
 * Which of Products' optional views the caller may open (Products itself is
 * always there). The switch draws an option per true flag; the catalogue's bar
 * draws the switch only when `any`. Each flag is the view's own gate, so the
 * switch never offers a view that refuses. Reads only what is loaded: no call.
 */
export function useProductsViews(): ProductsViews {
  const baseGarments = useBaseGarmentsAccess();
  const clientPrices = useClientPricesAccess();
  return { baseGarments, clientPrices, any: baseGarments || clientPrices };
}
